
<script>
	import datetree from './datetree/tree.vue'
	import listBase from '@_system/components/base/list.vue'
	import importtaskIndex from '@_system/components/importtask/index.vue'
	import detailIndex from './detail/index.vue'
import { isNumber } from 'xe-utils'
	export default {
		extends: listBase,
		name: 'expressreconciliationIndex',
		props: {

		},
		render(h) {
			this.$slots.mainheader = [
				<el-tag type="danger" size="mini">账单模板: 录入时间 | 运单编号 | 重量 | 费用 </el-tag>,
			]
			this.$slots.aside = [ <datetree ref = "datetree" key = {this.datetreeKey} onSelect = {this.datetreeChange}/>]
			this.$slots.plug = [
				<importtask-index type="expressreconciliation" ref = "importtaskIndex" /> , 
				<detail-index row={this.currentrow} ref = "detailIndex" onSubmit={this.detailSubmit} /> , 	
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				moduleName: 'expressreconciliation',
				windowName: '快递对账',
				windowType: 'modal',
				billtime:[],
				currentrow:{},
				// statisticsfield:'weight,amount',
				datetreeKey:Math.random(),
				defaultFormValue:[{
					field:"sendDate",
					default:[
						this.$Moment().subtract(1, 'month').startOf('month').valueOf(),
						this.$Moment().subtract(1, 'month').endOf('month').valueOf()
					]
				}],
				list_footerField: [{
					field: 'wlnweight',
					toFixed: 4
				},{
					field: 'wlnamount',
					toFixed: 2
				},{
					field: 'billamount',
					toFixed: 2
				},{
					field: 'billweight',
					toFixed: 4
				},{
					field: 'diffweight',
					toFixed: 4
				},{
					field: 'diffamount',
					toFixed: 2
				}]
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			
		},
		computed: {

		},

		methods: {
			autocheck(row){
				this.$confirm('是否确认自动核对?').then(()=>{
					this.loading = true
					this.$api.expressreconciliation.autocheck({
						billcode:row.code
					}).then(()=>{		
						this.$message.success('已添加自动核对任务')
						this.$refs[this.moduleName + '_list'].commitProxy('query')
						this.loading = false
					},()=>{
						this.loading = false
					})
				})
			},
			detailSubmit(){
				this.$refs[this.moduleName + '_list'].commitProxy('query')
			},
			reconciliation(row){
				this.currentrow = row
				this.$nextTick(()=>{
					this.$refs.detailIndex.list_init()
					this.$refs.detailIndex.modal_show()
				})
				
			},
			bill(row){
				this.currentrow = row
				this.$refs[this.moduleName+'_list'].importData()
			},
			add() {
				if(this.billtime.length==0 || this.billtime[0].toString().startsWith('year')){				
					this.$message.error('请选择月份')
					return
				}
				this.addformShow({
					billtime:this.billtime[0],
				})
			},
			datetreeChange(e){
				//console.log(e)
				this.billtime = e.parentid != 0 ? [e.id] : e.childrenid
				if(isNumber(this.billtime[0])){
					this.foreingKey.billtime = this.billtime[0]/1000
					this.$refs[this.moduleName + '_list'].commitProxy('query')					
				}else{
					this.$refs[this.moduleName + '_list'].commitProxy('query')
				}

				
			},
			importtask(){
				this.$refs.importtaskIndex.modal_show()
			},
			importMethod(e){
				let file = e.file
				let formData = new FormData()
				formData.append('file', file, file.name)
				formData.append('filename', file.name)
				formData.append('billcode', this.currentrow.code)
				formData.append('billtime', this.currentrow.billtime)
				this.loading = true
				this.$api.expressreconciliation.uploadfile(formData).then(()=>{
					this.$refs[this.moduleName + '_list'].commitProxy('query',{billtime:this.currentrow.billtime})
					this.$message.success('创建导入任务成功')
					this.importtask()
					this.loading = false
				},()=>{
					this.loading = false
				})			
			}
		},
		components: {
			importtaskIndex,
			detailIndex
		}
	}
</script>
